import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { InputDateComponent } from './components/inputs/input-date/input-date.component';
import { NumberOnlyControlDirective } from './directives/inputs/input-control-number-only/input-control-number-only.directive';
import { DecimalOnlyControlDirective } from './directives/inputs/input-control-decimal-only/input-control-decimal-only.directive';
import { DesignTemplatePipe, PlacementPipe, PlatformPipe, DeviceModelPipe, OSPipe, SDKVersionPipe, UserPipe, DealPipe } from './pipes';
import { PlacementRelationPipe, OSGroupPipe, SDKVersionGroupPipe, DeviceModelGroupPipe } from './pipes';

import { UiSwitchModule } from 'ngx-ui-switch';
import { ClipboardModule } from 'ngx-clipboard';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { NgSelectModule } from '@ng-select/ng-select';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';

import {
  faAsterisk,
  faBars,
  faUserCircle,
  faPowerOff,
  faCog,
  faPlayCircle,
  faRocket,
  faPlus,
  faEdit,
  faTrash,
  faTimes,
  faCaretUp,
  faCaretDown,
  faExclamationTriangle,
  faExclamationCircle,
  faFilter,
  faTasks,
  faCheck,
  faSquare,
  faLanguage,
  faPaintBrush,
  faLightbulb,
  faWindowMaximize,
  faStream,
  faBook,
  faCalendar,
  faSpinner,
  faAngleUp,
  faAngleDown,
  faChevronCircleUp,
  faChevronCircleDown,
  faQuestionCircle,
  faBell,
  faEye,
  faInfoCircle,
  faUser,
  faClock,
  faSortAmountUp,
  faSortAmountDown,
  faPauseCircle,
  faCode,
  faExclamation,
} from '@fortawesome/free-solid-svg-icons';
import { HighlightModule } from 'ngx-highlightjs';
import { EnvironmentService } from '@app/core';

import {
  faCopy,
  faTimesCircle,
} from '@fortawesome/free-regular-svg-icons';
import { PaginateComponent } from './components/paginate/paginate.component';
import { HistoryComponent } from './components/history/history.component';
import { ItemLengthComponent } from './components/item-length/item-length.component';
import { SortComponent } from './components/sort/sort.component';
import {
  IgxTextSelectionModule, IgxMaskModule, IgxDatePickerModule, IgxIconModule, IgxButtonModule, IgxInputGroupModule, IgxStepperModule
} from 'igniteui-angular';
import { HammerModule } from '@angular/platform-browser';
import localeJa from '@angular/common/locales/ja';
import { QRCodeComponent } from 'angularx-qrcode';
registerLocaleData(localeJa);

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,

    BsDropdownModule.forRoot(),
    ButtonsModule.forRoot(),
    ClipboardModule,
    FontAwesomeModule,
    ModalModule.forRoot(),
    NgSelectModule,
    HighlightModule,
    HammerModule,
    IgxIconModule,
    IgxDatePickerModule,
    IgxButtonModule,
    IgxInputGroupModule,
    IgxMaskModule,
    IgxTextSelectionModule,
    IgxStepperModule,
    QRCodeComponent,
    UiSwitchModule,
  ],
  declarations: [
    InputDateComponent,
    NumberOnlyControlDirective,
    DecimalOnlyControlDirective,
    PaginateComponent,
    HistoryComponent,
    ItemLengthComponent,
    SortComponent,

    DesignTemplatePipe,
    PlacementPipe,
    PlatformPipe,
    DeviceModelPipe,
    OSPipe,
    SDKVersionPipe,
    HistoryComponent,
    UserPipe,
    PlacementRelationPipe,
    DeviceModelGroupPipe,
    OSGroupPipe,
    SDKVersionGroupPipe,
    DealPipe,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,

    FontAwesomeModule,
    NgSelectModule,
    HighlightModule,

    InputDateComponent,
    NumberOnlyControlDirective,
    DecimalOnlyControlDirective,
    PaginateComponent,
    HistoryComponent,
    ItemLengthComponent,
    SortComponent,

    DesignTemplatePipe,
    PlacementPipe,
    PlatformPipe,
    DeviceModelPipe,
    OSPipe,
    SDKVersionPipe,
    UserPipe,
    PlacementRelationPipe,
    DeviceModelGroupPipe,
    OSGroupPipe,
    SDKVersionGroupPipe,
    DealPipe,

    ClipboardModule,
    BsDropdownModule,
    ButtonsModule,
    IgxStepperModule,
    ModalModule,
    QRCodeComponent,
    UiSwitchModule,
  ],
  providers: [
    EnvironmentService,
    { provide: LOCALE_ID, useValue: 'ja-JP' },
  ],
})
export class SharedModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(
      faAsterisk,
      faBars,
      faUserCircle,
      faPowerOff,
      faCog,
      faRocket,
      faPlayCircle,
      faPlus,
      faEdit,
      faTrash,
      faTimes,
      faCaretUp,
      faCaretDown,
      faExclamationTriangle,
      faExclamationCircle,
      faFilter,
      faTasks,
      faCheck,
      faSquare,
      faLanguage,
      faPaintBrush,
      faLightbulb,
      faWindowMaximize,
      faStream,
      faBook,
      faCalendar,
      faSpinner,
      faAngleUp,
      faAngleDown,
      faChevronCircleUp,
      faChevronCircleDown,
      faQuestionCircle,
      faEye,
      faInfoCircle,
      faUser,
      faClock,
      faBell,
      faCopy,
      faSortAmountUp,
      faSortAmountDown,
      faPauseCircle,
      faCode,
      faTimesCircle,
      faExclamation,
    );
  }
}
